
import { SetupContext, defineComponent, onMounted, getCurrentInstance, ref, watch, computed } from 'vue';

const GoogleAD = defineComponent({
    props: {
        index: {
            type: Number,
            default: 0,
        },
        googleAdStyle: {
            type: Number,
            default: 0,
        },
    },
    emits: ['onGoogleAdLoad'],
    setup(props, ctx: SetupContext<Array<'onCancel' | 'onDelete' | 'onLogout' | 'onGoogleAdLoad'>>) {
        const google_index = `adsbygoogleid-${props.index}`;
        let adsbygoogle;
        onMounted(() => {
            (adsbygoogle = window.adsbygoogle || []).push({});
            const targetNode = document.getElementById(google_index) as Element;
            const config = {
                attributes: true,
                attributeOldValue: true,
                attributeFilter: ['data-ad-status'],
            };

            const callback = function (mutationsList: any, observer: any) {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'data-ad-status') {
                        const data_ad_status = mutation.target.getAttribute('data-ad-status');
                        if (data_ad_status === 'unfilled') {
                            ctx.emit('onGoogleAdLoad', props.index);
                        }
                    }
                }
            };

            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        });
        return { adsbygoogle, google_index };
    },
});

export default GoogleAD;
